import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260115_component_instance_vertical_placement",
  description: "Remove LEVEL component members and migrate component instance vertical placement",
  apply(json: any): any {
    const { componentMembers = {}, componentInstances = {} } = json;

    for (const hash in componentMembers) {
      if (hash.startsWith("level.")) {
        delete json.componentMembers[hash];
      }
    }

    for (const instanceId in componentInstances) {
      const instance = componentInstances[instanceId];

      componentInstances[instanceId] = {
        ...instance,
        verticalPlacement: {
          type: "REPLICATION",
          datumUsage: instance.datumUsage,
        },
      };

      delete componentInstances[instanceId].datumUsage;
    }

    return json;
  },
};

export default migration;
